<div class="confirmation-container">
  <div class="confirmation-title">Finished uploading</div>
  <div class="confirmation-subtitle">
    Your {{ submittedFileCount() }} {{ submittedFileCount() === 1 ? 'file' : 'files' }} have been successfully uploaded
    to {{ firmName() }}.
  </div>
  <button andButton color="primary" size="large" class="primary" (click)="uploadMore.emit()">Upload More Files</button>
  <div class="footer-area">
    <span>Your files will be securely uploaded to {{ firmName() }}.</span>
  </div>
</div>
